import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MeetingDto } from '@interfaces/meetings/responses/meeting.response';
import { SharedModule } from '@src/app/shared/shared.module';
import { MeetingTimelineComponent } from '@features/dashboard/meetings/pages/meeting-detail/components/meeting-timeline/meeting-timeline.component';
import { MeetingParticipantsComponent } from '@features/dashboard/meetings/components/meeting-participants/meeting-participants.component';
import {
  nomesDasAgendas,
  rotuloDaOrigem,
} from '@features/dashboard/meetings/components/meeting-presenter';

/**
 * Aba **Detalhes** da tela de detalhe: participantes e, para o time interno, de onde veio o bot.
 *
 * Até o redesenho esta era a coluna lateral inteira (card 3162). Deals e vínculos foram para a aba
 * Vínculos (`app-meeting-links-panel`) e os JSON crus da Recall para o menu "…" do cabeçalho.
 */
@Component({
  selector: 'app-meeting-detail-side',
  standalone: true,
  imports: [SharedModule, MeetingParticipantsComponent, MeetingTimelineComponent],
  templateUrl: './meeting-detail-side.component.html',
  styleUrl: './meeting-detail-side.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingDetailSideComponent {
  readonly meeting = input.required<MeetingDto>();
  /** Time interno: mostra "Sobre o bot". */
  readonly interno = input(false);

  protected readonly origem = rotuloDaOrigem;
  protected readonly nomesDasAgendas = nomesDasAgendas;
}
